import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useI18n } from "@/i18n/I18nProvider";

export function AuthShell({ children }) {
  const { t, toggle, lang } = useI18n();
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-sand">
      <div className="hidden lg:flex flex-col justify-between bg-navy p-12 text-white relative overflow-hidden">
        <img src="/hero-skyline-sm.webp" alt="" className="absolute bottom-0 inset-x-0 w-full h-1/2 object-cover object-bottom opacity-30" />
        <Link to="/" className="relative"><Logo variant="dark" /></Link>
        <div className="relative">
          <h1 className="text-4xl font-bold leading-tight">{t("hero.title")}</h1>
          <p className="mt-4 text-white/80">{t("auth.side")}</p>
        </div>
        <div className="crenel relative" />
      </div>
      <div className="flex flex-col items-center justify-center p-4 gap-4">
        <div className="flex w-full max-w-[400px] items-center justify-between lg:hidden">
          <Link to="/" className="rounded-xl bg-navy p-2"><Logo variant="dark" /></Link>
        </div>
        <button onClick={toggle} data-testid="auth-lang-toggle" className="btn-ghost h-8 text-xs">{lang === "ar" ? "English" : "عربي"}</button>
        <div className="w-full flex justify-center">{children}</div>
      </div>
    </div>
  );
}
